class WindowProxy {
    get() {
        return typeof window !== 'undefined' && window.toString() === '[object Window]' && window;
    }

    location() {
        return this.get() && window.location;
    }

    localStorage() {
        return this.get() && window.localStorage;
    }

    sessionStorage() {
        return this.get() && window.sessionStorage;
    }

    getFBApi() {
        return this.get() && window.FB;
    }
}

export default new WindowProxy();
